module.exports = __webpack_public_path__ + "img/b_m.2a482fce.png";